let escapeMap = {
  '&':'&amp;',
  '<':'&lt;',
  '>':'&gt;',
  '"':'&quot;',
};
export const escape =  function (str) {
  return str.replace(/[&<>"]/g, function(result) {
    return escapeMap[result]
  })
};

let unescapeMap = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
};
export const unescape = function escapeHtml(str) {
    return str.replace(/&amp;|&lt;|&gt;|&quot;/g, function(result) {
      return unescapeMap[result]
    })
};

/**
 * 转义对象里的html标识符
 * @param obj
 */
export const escapeObj = function escapeHtml(obj) {
  for (let k in obj) {
    if (!obj.hasOwnProperty(k))
      continue;
    if (typeof obj[k] === 'string') {
      obj[k] = escape(obj[k])
    } else if (typeof obj[k] === 'object') {
      escapeObj(obj[k]);
    }
  }
  return obj;
};



// WEBPACK FOOTER //
// ./src/js/utils/XSSFilter.js